<template>
    <div>
        <h1>How to scout/track</h1>
        <p>Fill player names during loading screen or PvE rounds and remove yourself from the blocks above, swap to selecting matched players (Click to match button) and then click on each player that you were fighting in correct order. The app will tell you your potential enemies. Green (SAFE) block means you can't fight against that player. Red (DANGER) block means you can fight against that player.</p>
    </div>
</template>

<script>
    export default {
        name: "HowToScout"
    }
</script>

<style>
</style>